<template>
  <div :id="id" style="position: absolute; opacity: 0">
    <img
      style="
        max-width: 100%;
        max-height: 100%;
        margin-left: auto;
        margin-right: auto;
      "
      :id="name"
      :usemap="'#' + useMap"
      :src="img"
      alt="The Boat Desarrollo Inmobiliario Playa del Carmen"
      @load="mapSetter"
      crossOrigin="Anonymous"
    />
    <map :name="useMap" id="data" v-for="(item, i) in coords" :key="i">
      <area target="" alt="" title="" href="#" :coords="item" shape="poly" />
    </map>
  </div>
</template>

<script>
import $ from "jquery";
import {} from "imagemapster";
export default {
  name: "CoordinateMapper",
  props: {
    id: {
      String: String,
      default: ""
    },

    img: {
      String: String,
      default: null
    },
    coords: {
      Array: Array,
      default: []
    },
    real_estate_group_id: {
      String: String,
      default: null
    }
  },
  computed: {
    name() {
      return "name" + this.id;
    },
    useMap() {
      return "map" + this.id;
    }
  },
  created() {
    this.mapSetter();
  },

  methods: {
    mapSetter() {
      $("#" + this.name).mapster({
        fillColor:
          this.real_estate_group_id &&
          this.real_estate_group_id === "65df671efde633d2f2489eda"
            ? "EF4444"
            : "FFC300",
        fillOpacity: 0.5,
        staticState: true
      });
    }
  }
};
</script>
